import React from 'react';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { Box, Button, Tooltip } from '@mui/material';

import {
  FlippableTrussEnvelope,
  flipTrussEnvelope,
} from '../../../../../library/layout-geometry/truss-envelopes/flipTrussEnvelope';
import { TrussEnvelopeInsertionInformation } from '../../../../../library/layout-geometry/truss-envelopes/insertion-information';
import { setInsertionTrussEnvelopeProperties } from '../../../../../store/slices/applicationSlice';
import { useAppDispatch } from '../../../../hooks';

export const FlipTrussEnvelopeButton = <T extends FlippableTrussEnvelope>(props: {
  disabled?: boolean;
  envelopes: readonly T[];
  onClick: (flippedEnvelope: readonly T[]) => void;
}) => (
  <Tooltip disableInteractive title="Flip envelope">
    <Box component="span" sx={{ display: 'flex', justifyContent: 'center' }}>
      <Button
        fullWidth
        variant="outlined"
        disabled={props.disabled}
        startIcon={<SwapVertIcon />}
        onClick={() => props.onClick(props.envelopes.map(flipTrussEnvelope))}
      >
        Flip Envelope
      </Button>
    </Box>
  </Tooltip>
);

export const FlipInsertionTrussEnvelopeButton = (props: { insertion: TrussEnvelopeInsertionInformation }) => {
  const dispatch = useAppDispatch();
  return (
    <FlipTrussEnvelopeButton
      disabled={!(props.insertion.data.leftPoint && props.insertion.data.rightPoint)}
      envelopes={[props.insertion.data]}
      onClick={([flippedEnvelope]) => dispatch(setInsertionTrussEnvelopeProperties(flippedEnvelope))}
    />
  );
};
